/**
 * This file contains the route manager. All pages of the application are declared here.
 * The route management is basically mapping a given URL to a React component.
 */

import React from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Route as RouteDom, Switch, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
// Components
import HomePage from './home/';

// import LoginPage from './login';
import LoginIDPage from './loginID';
import ViaDialogPage from './viadialog';
// import ForgotPasswordPage from './forgot';
import ProfilPage from './profil';

import PartnersListPage from './partners/list';
import PartnerViewPage from './partners/view';
import PartnerEditPage from './partners/edit';
import PartnerAddPage from './partners/add';
import PartnerAddVehiclePage from './partners/vehicleAdd';
import PartnerAddDriverPage from './partners/driverAdd';
import PartnerAddManagerPage from './partners/managerAdd';
import PartnerManagerViewPage from './partners/managerView';
import PartnerEditManagerPage from './partners/managerEdit';

import DriversListPage from './drivers/list';

import DriverViewPage from './drivers/view';
import DriverEditPage from './drivers/edit';
import DriverStatsPage from './drivers/stats';
import DriversIssuesPage from './drivers/issues';
import DriversTopPage from './drivers/top';
import RidersListPage from './riders/list';
import RiderViewPage from './riders/view';
import RiderEditPage from './riders/edit';
import RiderAddPromoPage from './riders/addPromo';

import VehicleViewPage from './vehicles/view';
import VehicleEditPage from './vehicles/edit';
import VehicleListPage from './vehicles/list';
import VehicleTypesListPage from './vehicles/types';
import VehicleAddTypeListPage from './vehicles/typeAdd';

import CompaniesListPage from './companies/list';
import CompaniesViewPage from './companies/view';
import CompaniesAddPage from './companies/add';
import CompaniesEditPage from './companies/edit';
import CompaniesAddDepartmentPage from './companies/departmentAdd';
import CompaniesAddMemberPage from './companies/memberAdd';
import CompaniesAddContractPage from './companies/contractAdd';
import CompaniesEditContractPage from './companies/contractEdit';
import CompaniesAddRestrictionPage from './companies/restrictions';

import BookingsListPage from './bookings/list';
import BookingsViewPage from './bookings/view';
import BookingRefoundPage from './bookings/refound';

import ReservationsListPage from './reservations/list';
import ReservationsViewPage from './reservations/view';
import ReservationsEditPage from './reservations/edit';
// import ReservationsRecurrentAddPage from './reservations/recurrentAdd';
// import ReservationsRecurrentsListPage from './reservations/recurrentList';

import BillsSimpleListPage from './bills/list_simple';
import BillsGroupedListPage from './bills/list_grouped';
import BillsGroupedPendingListPage from './bills/list_grouped_pending';
import BillsCreditListPage from './bills/list_credit';
import BillsCreditAddPage from './bills/creditAdd';
import BillsCreditMonthListPage from './bills/list_credit_month';
import BillsCreditExceptionalListPage from './bills/list_credit_exceptional';
import BillsExceptionalListPage from './bills/list_exceptional';
import BillsExceptionalAddPage from './bills/exceptionalAdd';
import BillsRectificationListPage from './bills/list_rectification';
import BillsRectificationAddPage from './bills/rectificationAdd';

import PartnerBillsPage from './partner-bills/list';
import PartnerBillsPendingPage from './partner-bills/pending';
// import PartnerBillsTransactionsPage from './partner-bills/transactions';
import PartnerBillViewPage from './partner-bills/view';
// import PartnerBillEditPage from './partner-bills/edit';

import PricingAreasListPage from './pricing/manageAreas/list';
// import PricingAreasViewPage from './pricing/manageAreas/view';
import PricingAreasAddPage from './pricing/manageAreas/add';

import PricingPricesListPage from './pricing/managePrices/list';
import PricingPricesViewPage from './pricing/managePrices/view';
import PricingPricesAddPage from './pricing/managePrices/add';
import PricingPricesAddTariffHoroPage from './pricing/managePrices/addTariffHoro';
import PricingPricesAddTariffForfaitPage from './pricing/managePrices/addTariffForfait';
import PricingPricesAddTariffDispoPage from './pricing/managePrices/addTariffDispo';

import PricingFeesListPage from './pricing/manageFees/list';
import PricingFeesAddPage from './pricing/manageFees/add';

import ControlTowersListPage from './control_towers/list/towers-list';
import ControlTowersAddPage from './control_towers/add/towers-add';

import SnapPayPage from './snappay';

import ReserverPage from './reserver';
import ReserverViewPage from './reserver/reserver-view';
import ReserverAddPage from './reserver/reserver-add';

import TicketingListPage from './ticketing/list';
import TicketingAddPage from './ticketing/add';

import CypherDescypherPage from './support/cypher';

import PrebooksListPage from './prebooks/list';
import PrebooksAddPage from './prebooks/add';
import PrebooksAddPlanningPage from './prebooks/addPlanning';

import MarketingPromoListPage from './marketing/promo-list';
import MarketingPromoAddPage from './marketing/promo-add';
import MarketingFidB2CPage from './marketing/fidb2c-add';

import AdminListPage from './admin/list';
import AdminUserViewPage from './admin/view';

import RanksListPage from './ranks/list';
import RanksFormPage from './ranks/add/ranks-add';
import DriverCommunicationsListPage from './driver_communications/list';
import DriverCommunicationsFormPage from './driver_communications/add';

import RidesImportPage from './rides/import/rides-import';

import Error404Page from './error/error404';

//==================================//
//====== NEWS ROUTES PRIVAPI =======//
//==================================//

import RidesListPage from './rides/list';
import RidesViewPage from './rides/view';

import UsersListPage from './users/list';
import UsersViewPage from './users/view';
import UsersEditPage from './users/edit';

import ContractsListPage from './contracts/list';
import ContractsViewPage from './contracts/view';
import ContractsEditPage from './contracts/edit';

import withErrorBoundaryHOC from '../components/error-boundaries/error-boudary-hoc';

// Modules
import { actions as errorActions, selectors as errorSelectors, ErrorPayload } from '../redux/reducers/errors';
import { actions as loginActions } from '../redux/reducers/login/module';
import UserUtils from '../utils/userUtils';
// Ressources
import { getHistory } from '../utils/historyUtils';
import { paths } from './paths';

//  Enhanced Route Component with ErrorBoundary
const Route = withErrorBoundaryHOC(RouteDom);

const history = getHistory();

interface MainRouterProps {
    allErrors: ErrorPayload[];
    clearAllErrors: () => void;
    dispatch: (action: any) => any;
}

const MainRouter = (props: MainRouterProps): JSX.Element => {
    const { allErrors, clearAllErrors, dispatch } = props;

    // Schedule token renewal if user is already logged in
    React.useEffect(() => {
        const token = Cookies.get('token');
        const user = UserUtils.getUser();
        if (token && user) {
            dispatch(loginActions.scheduleRenewAction());
        }
    }, [dispatch]);

    // function called when page change
    React.useEffect(() => {
        history.listen((location, action) => {
            if (allErrors?.length) {
                clearAllErrors();
            }
        });
    }, [allErrors, clearAllErrors]);

    // noinspection RequiredAttributes
    return (
        <ConnectedRouter history={history}>
            <Switch>
                <Route exact path={paths.home} component={HomePage} />
                {/* <Route exact path={paths.login} component={LoginPage} /> */}
                <Route exact path={paths.login} component={LoginIDPage} />
                {/* <Route exact path={paths.viadialog} component={ViaDialogPage} /> */}
                {/* <Route exact path={paths.forgot} component={ForgotPasswordPage} /> */}
                <Route exact path={paths.profil} component={ProfilPage} />

                <Route exact path={paths.partners} component={PartnersListPage} />
                <Route exact path={paths.partnersAdd} component={PartnerAddPage} />
                <Route exact path={paths.partnersDetails} component={PartnerViewPage} />
                <Redirect push exact from={paths.partnersManagers} to={paths.partnersDetails} />
                <Redirect push exact from={paths.partnersDrivers} to={paths.partnersDetails} />
                <Redirect push exact from={paths.partnersVehicles} to={paths.partnersDetails} />
                <Route exact path={paths.partnersEdit} component={PartnerEditPage} />
                <Route exact path={paths.partnersVehiclesAdd} component={PartnerAddVehiclePage} />
                <Route exact path={paths.partnersDriversAdd} component={PartnerAddDriverPage} />
                <Route exact path={paths.partnersManagersAdd} component={PartnerAddManagerPage} />
                <Route exact path={paths.partnersManagersDetails} component={PartnerManagerViewPage} />
                <Route exact path={paths.partnersManagersEdit} component={PartnerEditManagerPage} />

                <Route exact path={paths.drivers} component={DriversListPage} />
                {/* /!\ Must be declared before driversDetails (/drivers/:id) which would capture them */}
                <Route exact path={paths.driversStats} component={DriverStatsPage} />
                <Route exact path={paths.driversIssues} component={DriversIssuesPage} />
                <Route exact path={paths.driversTop} component={DriversTopPage} />
                <Route exact path={paths.driversDetails} component={DriverViewPage} />
                <Route exact path={paths.driversEdit} component={DriverEditPage} />

                <Route exact path={paths.riders} component={RidersListPage} />
                <Route exact path={paths.ridersDetails} component={RiderViewPage} />
                <Route exact path={paths.ridersEdit} component={RiderEditPage} />
                <Route exact path={paths.ridersPromotion} component={RiderAddPromoPage} />

                {/* Users = New version of Riders */}
                <Route exact path={paths.users} component={UsersListPage} />
                <Route exact path={paths.usersDetails} component={UsersViewPage} />
                <Route exact path={paths.usersEdit} component={UsersEditPage} />

                <Route exact path={paths.vehicles} component={VehicleListPage} />
                <Route exact path={paths.vehiclesEdit} component={VehicleEditPage} />
                <Route exact path={paths.vehiclesTypes} component={VehicleTypesListPage} />
                <Route exact path={paths.vehiclesTypesAdd} component={VehicleAddTypeListPage} />
                <Route exact path={paths.vehiclesDetails} component={VehicleViewPage} />

                {/* Contracts = New version of Companies */}
                <Route exact path={paths.contracts} component={ContractsListPage} />
                <Route exact path={paths.contractsDetails} component={ContractsViewPage} />
                <Route exact path={paths.contractsEdit} component={ContractsEditPage} />

                <Route exact path={paths.companies} component={CompaniesListPage} />
                <Route exact path={paths.companiesAdd} component={CompaniesAddPage} />
                <Route exact path={paths.companiesDetails} component={CompaniesViewPage} />
                <Redirect push exact from={paths.companiesDepartments} to={paths.companiesDetails} />
                <Redirect push exact from={paths.companiesMemberships} to={paths.companiesDetails} />
                <Redirect push exact from={paths.companiesContracts} to={paths.companiesDetails} />
                <Route exact path={paths.companiesEdit} component={CompaniesEditPage} />
                <Route exact path={paths.companiesDepartmentsAdd} component={CompaniesAddDepartmentPage} />
                <Route exact path={paths.companiesMembershipsAdd} component={CompaniesAddMemberPage} />
                <Route exact path={paths.companiesContractsAdd} component={CompaniesAddContractPage} />
                <Route exact path={paths.companiesContractEdit} component={CompaniesEditContractPage} />
                <Route exact path={paths.companiesRestrictions} component={CompaniesAddRestrictionPage} />

                {/* Rides = New version of booking/Reservation */}
                {/* <Route exact path={paths.rides} component={RidesListPage} />
                <Route exact path={paths.ridesDetails} component={RidesViewPage} /> */}

                {/* Bookings */}
                <Route exact path={paths.bookings} component={BookingsListPage} />
                <Route exact path={paths.bookingsDetails} component={BookingsViewPage} />
                <Route exact path={paths.bookingsRefund} component={BookingRefoundPage} />

                {/* Réservations */}
                <Route exact path={paths.reservations} component={ReservationsListPage} />
                {/* <Route exact path={paths.reservationsRecurrents} component={ReservationsRecurrentsListPage} />
                <Route exact path={paths.reservationsAdd} component={ReservationsRecurrentAddPage} /> */}
                <Route exact path={paths.reservationsDetails} component={ReservationsViewPage} />
                <Route exact path={paths.reservationsEdit} component={ReservationsEditPage} />

                {/* Facturations */}
                <Route exact path={paths.bills} component={BillsSimpleListPage} />
                <Route exact path={paths.billsSimple} component={BillsSimpleListPage} />
                <Route exact path={paths.billsPeriods} component={BillsGroupedListPage} />
                <Route exact path={paths.billsPeriodsPending} component={BillsGroupedPendingListPage} />
                <Route exact path={paths.billsCreditNotes} component={BillsCreditListPage} />
                <Route exact path={paths.billsCreditNotesAdd} component={BillsCreditAddPage} />
                <Route exact path={paths.billsMonthCreditNotes} component={BillsCreditMonthListPage} />
                <Route exact path={paths.billsExceptionalCreditNotes} component={BillsCreditExceptionalListPage} />
                <Route exact path={paths.billsExceptionals} component={BillsExceptionalListPage} />
                <Route exact path={paths.billsExceptionalsAdd} component={BillsExceptionalAddPage} />
                <Route exact path={paths.billsRectifications} component={BillsRectificationListPage} />
                <Route exact path={paths.billsRectificationsAdd} component={BillsRectificationAddPage} />
                <Route exact path={paths.billsPartnerPending} component={PartnerBillsPendingPage} />
                {/* <Route exact path=={paths.billsPartnerTransactions} component={PartnerBillsTransactionsPage} /> */}
                <Route exact path={paths.billsPartner} component={PartnerBillsPage} />
                <Route exact path={paths.billsPartnerDetails} component={PartnerBillViewPage} />
                {/* <Route exact path=={paths.billsPartnerEdit} component={PartnerBillEditPage} /> */}

                {/* Pricing */}
                <Redirect push exact from={paths.pricing} to={paths.pricingManageAreas} />
                <Route exact path={paths.pricingManageAreas} component={PricingAreasListPage} />
                <Route exact path={paths.pricingManageAreasAdd} component={PricingAreasAddPage} />
                {/* <Route exact path={paths.pricingManageAreasDetails} component={PricingAreasViewPage} /> */}

                <Route exact path={paths.pricingManagePrices} component={PricingPricesListPage} />
                <Route exact path={paths.pricingManagePricesAdd} component={PricingPricesAddPage} />
                <Route exact path={paths.pricingManagePricesDetails} component={PricingPricesViewPage} />
                <Route exact path={paths.pricingManagePricesNewTarifHkm} component={PricingPricesAddTariffHoroPage} />
                <Route
                    exact
                    path={paths.pricingManagePricesNewTarifForfait}
                    component={PricingPricesAddTariffForfaitPage}
                />
                <Route
                    exact
                    path={paths.pricingManagePricesNewTarifDispo}
                    component={PricingPricesAddTariffDispoPage}
                />

                <Route exact path={paths.pricingManageFees} component={PricingFeesListPage} />
                <Route exact path={paths.pricingManageFeesAdd} component={PricingFeesAddPage} />

                {/* Snappay */}
                {/* <Route exact path={paths.snappay} component={SnapPayPage} /> */}

                {/* Opérations */}
                <Route exact path={paths.controlTowers} component={ControlTowersListPage} />
                <Route exact path={paths.controlTowersAdd} component={ControlTowersAddPage} />

                <Route exact path={paths.prebooks} component={PrebooksListPage} />
                <Route exact path={paths.prebooksAdd} component={PrebooksAddPage} />
                <Redirect push exact from={paths.prebooksDetails} to={`${paths.prebooks}?prebook_id=:id`} />
                <Route exact path={paths.prebooksPlannings} component={PrebooksAddPlanningPage} />

                <Route exact path={paths.ranks} component={RanksListPage} />
                <Route exact path={paths.ranksAdd} component={RanksFormPage} />
                <Route exact path={paths.ranksEdit} component={RanksFormPage} />
                <Route exact path={paths.ridesImport} component={RidesImportPage} />
                <Route exact path={paths.driverCommunications} component={DriverCommunicationsListPage} />
                <Route exact path={paths.driverCommunicationsAdd} component={DriverCommunicationsFormPage} />
                <Route exact path={paths.driverCommunicationsEdit} component={DriverCommunicationsFormPage} />
                <Redirect exact from={paths.ranksDetails} to={paths.ranksEdit} />

                {/* Marketing */}
                <Redirect push exact from={paths.marketing} to={paths.marketingPromos} />
                {/* <Route exact path={paths.marketingPromos} component={MarketingPromoListPage} />
                <Route exact path={paths.marketingPromosAdd} component={MarketingPromoAddPage} /> */}
                <Route exact path={paths.marketingFidB2C} component={MarketingFidB2CPage} />

                {/* Admin */}
                <Route exact path={paths.admin} component={AdminListPage} />
                <Route exact path={paths.adminDetails} component={AdminUserViewPage} />

                {/* Ticketing */}
                {/* <Route exact path={paths.ticketing} component={TicketingListPage} />
                <Redirect push exact from={paths.ticketingDetails} to={`${paths.ticketing}?project=:project`} />
                <Route exact path={paths.ticketingProjectAdd} component={TicketingAddPage} /> */}

                {/* Support */}
                <Route exact path={paths.support} component={CypherDescypherPage} />

                {/* Reserver */}
                <Route exact path={paths.reserver} component={ReserverPage} />
                <Route exact path={paths.reserverDetails} component={ReserverViewPage} />
                <Route exact path={paths.reserverAdd} component={ReserverAddPage} />

                <Route component={Error404Page} />
            </Switch>
        </ConnectedRouter>
    );
};

const mapStateToProps = (state) => ({
    allErrors: errorSelectors.errors(state),
});

const mapDispatchToProps = {
    clearAllErrors: errorActions.clearAllErrors,
    dispatch: (action: any) => action,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainRouter);
